import React from "react";
import { EmptyDash } from "./EmptyDash";
import { WEIGHT_MULTIPLIER_DECIMAL_PLACES } from "utils/constants";
export default function WeightColumn({ value = "" }){
	let weightCellValue = null;
	let { isNaN, isInteger } = Number;

	if(value && Number(value) > 0){
		if(isInteger(value)){
			weightCellValue = `${Number(value)}x`;
		} else {
			weightCellValue = `${Number(value).toFixed(WEIGHT_MULTIPLIER_DECIMAL_PLACES)}x`;
		}
	}
	if(!value || Number(value) === 0 || isNaN(Number(value))) {
		weightCellValue = <EmptyDash />;
	}

	return (
		<span>{weightCellValue}</span>
	);
}


WeightColumn.displayName = "WeightColumn";
